exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\nagm-map {\r\nheight: 30em;\r\n\r\n}\r\n.img{\r\n  height: 2.5em;\r\n}\r\n#perfil{\r\n  position: absolute;\r\n  z-index: 100;\r\n}\r\n#login{\r\n  position: absolute;\r\n  z-index: 100;\r\n}\r\n@media screen and (max-width: 600px){\r\nagm-map{\r\n  height: 18em;\r\n}\r\n}\r\n@media screen and (min-width: 1500px){\r\n  .margenes{\r\n    margin-left:45px;\r\n    margin-right: 45px;\r\n  }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/xikoo/Desktop/cursoAngular4/node_modules/css-loader?{"sourceMap":false,"import":false}!C:/Users/xikoo/Desktop/cursoAngular4/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Users/xikoo/Desktop/cursoAngular4/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles